import React from "react";
import shoppingBag from "@/public/images/shoppingBag.svg";

const root = window?.post_template?.checkout_v4_header;
const shoppingBagIcon = root.checkout_v4_header_shoppingBag ? root.checkout_v4_header_shoppingBag : shoppingBag;
const logo = root.checkout_v4_header_globalLogo ? window.general_settings.logo : root.checkout_v4_header_customLogo;
const backgroundColor = root.checkout_v4_header_background;
const borderColor = root.checkout_v4_header_borderColor;

const Header = () => {
  return (
    <header className="topLine__header" style={{ background: backgroundColor, borderColor: borderColor }}>
      <div className="topLine">
        <img className="topLine__logo" src={logo} alt={window.general_settings.brand_name} height="24" width="124" />
        <div className="topLine__itemsLeft">
          <a
            style={{ cursor: "pointer" }}
            onClick={() => {
              // no #products without the picker: fall back to the order summary
              const element = document.querySelector("#products") ?? document.querySelector(".orderOverviewDrawerV4");
              element?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
            }}
          >
            <img
              className="topLine__shoppingBag"
              style={{ pointerEvents: "none" }}
              src={shoppingBagIcon}
              alt={general_settings.brand_name}
            />
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
